export const environment = {
  production: true,
  buildId: '3461904960722191',
  configFile: 'config.json',
};
